import { defineStore } from 'pinia'
// import { PURGE_AUTH, SET_AUTH } from './mutation.type'
import { getOauthTokenApi, logoutApi } from '@/api/auth'
import type { CompanyList, DataInfo, Gender } from '@/types/global'
// console.log(localStorage.getItem("username"))
import {
  clearStorage,
  getCompanyList,
  getToken,
  setCompanyList,
  setToken,
} from '@/utils/auth'
// export const state = {
//   isAuthenticated: !!getAccessToken(),
//   username: localStorage.getItem('username') || '',
//   expirationIn: '', // 过期时间

// }

export const useUserStore = defineStore('user', () => {
  const gender = ref<Gender>(getToken()?.gender)
  const companyList = ref<CompanyList>(getCompanyList())

  function updateUser(result: DataInfo) {
    gender.value = result.gender
    companyList.value = result.company

    // tenantList.value = result.company.filter(({ identityName }) => {
    //   return identityName.includes('tenant')
    // })

    setCompanyList(companyList.value)
    setToken(result)
  }

  function login(formFields: object): Promise<DataInfo> {
    return new Promise((resolve, reject) => {
      getOauthTokenApi({
        ...formFields,
        // serviceSubType,
      })
        .then((res) => {
          resolve(res)
        })
        .catch((error) => {
          console.log('error', JSON.stringify(error))
          reject(error)
        })
    })
  }

  async function logout() {
    try {
      if (getToken()) await logoutApi()
      clearStorage()
    } catch (err) {
      // ElMessage.error(err)
    }
  }

  // export const mutations = {
  //   [SET_AUTH](state, user) {
  //     const { username, access_token, refresh_token } = user
  //     state.isAuthenticated = true
  //     state.username = username
  //     localStorage.setItem('username', username)
  //     setAccessToken(access_token)
  //     setRefreshToken(refresh_token)
  //   },
  //   [PURGE_AUTH](state) {
  //     state.isAuthenticated = false
  //     removeCompanyId()
  //     removeAccessToken()
  //     removeRefreshToken()
  //   },
  // }

  // export const actions = {
  //   login({ commit }, params) {
  //     return new Promise((resolve, reject) => {
  //       getOauthTokenApi(params)
  //         .then((res) => {
  //           commit(SET_AUTH, {
  //             ...res,
  //             username: params.username,
  //           })

  //           resolve(res)
  //         })
  //         .catch((error) => {
  //           reject(error)
  //         })
  //     })
  //   },

  //   logout({ commit }) {
  //     return new Promise((resolve) => {
  //       logoutApi().then(() => {
  //         commit(PURGE_AUTH)
  //         resolve()
  //       })
  //     })
  //   },

  //   resetToken({ commit }) {
  //     commit(PURGE_AUTH)
  //   },
  // }

  return {
    gender,
    companyList,
    login,
    logout,
    updateUser,
  }
})
